
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Automation Template Gallery
   
    <button mat-icon-button (click)="closeImportTaskTemplate()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
 

    <div class="template-holder">
      <div class="left">

        <mat-form-field appearance="fill">
          <mat-label>Select Category</mat-label>
          <mat-select (selectionChange)="onTaskListTabChangeForTaskImport($event)" value="My Template">
            <mat-option value="My Template">My Template</mat-option>
            <mat-option value="Organization">Organization</mat-option>
            <mat-option value="Global">Global</mat-option>           
            <!-- <mat-option value="Global">Global</mat-option> -->
          </mat-select>
        </mat-form-field>

        <div class="list" #categoryList>
          <ul>
            <li (click)="getTaskListThroughCategoryForTaskImport(0, 0)" [ngClass]="{'active': currentIndex == 0 }" >All</li>
            <ng-container  *ngFor="let stat of filteredTaskCategoryList; let i = index">
              <li (click)="getTaskListThroughCategoryForTaskImport(stat.taskTemplateCategoryID, i+1)" [ngClass]="{'active': currentIndex == i+1 }"  > {{ stat.taskTemplateCategoryName }}</li>
            </ng-container>           
          </ul>
        
        </div>

      </div>
     <div class="right"> 
       
      

       <div class="searrch">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search</mat-label>
          <input matInput maxlength="20" placeholder="Search Template"
            (input)="searchTemplateForSingleTask($event.target.value)">
        </mat-form-field>
       </div>
  
      

        <div class="tempalteList">
          <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundTaskTemplates">
            <tr>
              <th> </th>
              <th>Template Name</th>             
              <th class="">&nbsp;</th>
            </tr>
            <tr *ngFor="let template of  TaskTemplatesListForSingleTask"
             [ngClass]="{ 'active': getTemplateID(template) === taskTemplateIDForSingleTask}">

             <td>
              <mat-radio-button color="primary" name="automationTemplate"
                [value]="getTemplateID(template)"
                [checked]="getTemplateID(template) === taskTemplateIDForSingleTask"
                (change)="selectTemplate(template)">
              </mat-radio-button>
            </td> 

              <td class="formName">
                {{template.templateName}}
              </td>            

              <td>
                &nbsp;
              </td>
            </tr>
          </table>
          <div *ngIf="ShowNoRecordFoundTaskTemplates" class="noRecordFound">No Record Found</div>
        </div>

     
  
     </div>
  </div>  

  <!-- <section class="importTo" *ngIf="selectedTemplate.length>0">
    <p>Would you like to import data for the newly created task-list? If so, please select the appropriate options below. If not, simply uncheck any boxes you do not wish to pull data from.</p>
    <mat-checkbox color="primary" [(ngModel)]="AttachChecked" (change)="showOptions($event,'Attach')">Attach</mat-checkbox> &nbsp;
    <mat-checkbox color="primary" [(ngModel)]="AssigneeChecked" (change)="showOptions($event,'Assignee')">Assignee</mat-checkbox>&nbsp;
   
  </section> -->

  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeImportTaskTemplate()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary" *ngIf="selectedTemplate.length>0"
      (click)="importTaskTemplates()">
      Import     
    </button>
  </mat-dialog-actions> 

